export const HideHelpWidget = () => {
  window.document.body.classList.add('hide-help-widget');
};

export const UndoHideHelpWidget = () => {
  window.document.body.classList.remove('hide-help-widget');
};
